import React, { useEffect, useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '../DropdownMenu/DropdownMenu';

export function StudyBrowserSort({ servicesManager }: withAppTypes) {
  const { customizationService, displaySetService } = servicesManager.services;
  const sortFunctions = customizationService.getCustomization('studyBrowser.sortFunctions');

  const [selectedSort, setSelectedSort] = useState(sortFunctions[0]);
  const [sortDirection, setSortDirection] = useState('ascending');

  const handleSortChange = sortFunction => {
    setSelectedSort(sortFunction);
  };

  const toggleSortDirection = () => {
    setSortDirection(prev => (prev === 'ascending' ? 'descending' : 'ascending'));
  };

  useEffect(() => {
    displaySetService.sortDisplaySets(selectedSort.sortFunction, sortDirection);
  }, [displaySetService, selectedSort, sortDirection]);

  useEffect(() => {
    const subChanged = displaySetService.subscribe(
      displaySetService.EVENTS.DISPLAY_SETS_CHANGED,
      () => displaySetService.sortDisplaySets(selectedSort.sortFunction, sortDirection, true)
    );
    const subMeta = displaySetService.subscribe(
      displaySetService.EVENTS.DISPLAY_SET_SERIES_METADATA_INVALIDATED,
      () => displaySetService.sortDisplaySets(selectedSort.sortFunction, sortDirection, true)
    );
    return () => {
      subChanged.unsubscribe();
      subMeta.unsubscribe();
    };
  }, [displaySetService, selectedSort, sortDirection]);

  const isAscending = sortDirection === 'ascending';

  return (
    <div className="flex w-full items-center gap-1.5">
      <DropdownMenu>
        <DropdownMenuTrigger className="flex h-7 flex-1 items-center justify-between rounded-lg bg-card px-2.5 text-[12px] text-white/80 ring-1 ring-primary/20 transition-all duration-150 hover:bg-accent hover:ring-primary/40 focus:outline-none data-[state=open]:ring-primary/50">
          <span className="truncate">{selectedSort.label}</span>
          <svg className="ml-1.5 h-3 w-3 shrink-0 text-white/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-[140px]">
          {sortFunctions.map(sort => (
            <DropdownMenuItem
              key={sort.label}
              className={selectedSort.label === sort.label ? 'text-secondary font-medium' : 'text-white/80'}
              onSelect={() => handleSortChange(sort)}
            >
              {selectedSort.label === sort.label && (
                <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary" />
              )}
              {sort.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Direction toggle */}
      <button
        onClick={toggleSortDirection}
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-card ring-1 ring-primary/20 transition-all duration-150 hover:bg-accent hover:ring-primary/40"
        title={isAscending ? 'Ascending' : 'Descending'}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`h-3.5 w-3.5 text-secondary transition-transform duration-200 ${isAscending ? '' : 'rotate-180'}`}
        >
          <line x1="12" y1="19" x2="12" y2="5" />
          <polyline points="5 12 12 5 19 12" />
        </svg>
      </button>
    </div>
  );
}
